import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";

import classes from "./couponFilterPage.module.css";
import { SearchInput } from "../../../component/shared/formElements/searchInput/SearchInput";

import {
  setCouponSearch,
  clearCouponSearch,
} from "../../../store/couponFilterSlice";

export const CouponFilterPage = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const search = useSelector((state) => state.couponFilter.search);

  /* Sync URL → Redux on load / URL change */
  useEffect(() => {
    const searchParam = searchParams.get("search");
    dispatch(searchParam ? setCouponSearch(searchParam) : clearCouponSearch());
  }, [searchParams, dispatch]);

  /* Update URL + Redux together */
  const updateSearch = useCallback(
    (value) => {
      const params = new URLSearchParams(searchParams);

      if (value) {
        params.set("search", value);
        dispatch(setCouponSearch(value));
      } else {
        params.delete("search");
        dispatch(clearCouponSearch());
      }

      setSearchParams(params);
    },
    [dispatch, searchParams, setSearchParams]
  );

  return (
    <div className={classes.box}>
      <div className={classes.box__content}>
        <SearchInput
          placeholder="Search by Coupon Code"
          value={search ?? ""}
          onSearch={updateSearch}
          onClear={() => updateSearch("")}
        />
      </div>

      <div className={classes.box__content}>
        <Link to="/coupons/create" className={classes.box__btn}>
          Create Coupon
        </Link>
      </div>
    </div>
  );
};
